import { FunctionComponent } from 'react';
import { ENotificationVariant } from './types';
import { WarningAlt, Info, SuccessTick, WarningOctagon } from '@mafc/icon';
import COLORS from 'theme/colors';

export const IconMap: Record<ENotificationVariant, FunctionComponent<any>> = {
  [ENotificationVariant.WARNING]: WarningAlt,
  [ENotificationVariant.INFO]: Info,
  [ENotificationVariant.SUCCESS]: SuccessTick,
  [ENotificationVariant.ERROR]: WarningOctagon,
};

export const ColorsMap: Record<ENotificationVariant, any> = {
  [ENotificationVariant.WARNING]: COLORS.GOLDEN_BELL_500,
  [ENotificationVariant.INFO]: COLORS.BLUE_600,
  [ENotificationVariant.SUCCESS]: COLORS.SUCCESS_600,
  [ENotificationVariant.ERROR]: COLORS.ERROR_RED,
};
